import { render, staticRenderFns } from "./MemberListLink.vue?vue&type=template&id=25b86c0c&scoped=true&"
import script from "./MemberListLink.vue?vue&type=script&lang=js&"
export * from "./MemberListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b86c0c",
  null
  
)

export default component.exports